import $ from 'jquery';
import Immutable from 'immutable';
import BasePropertyView from 'BasePropertyView.js';
import _template from 'properties/table/column-main-name.ejs';
import util from 'util/Util';

class MainNameView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));

        // needs to set to the Column Name for this Column
        this.model.get('gridData')[this.colId].attributes[propName] = propVal;
        this.model.trigger('change');
    }


    render() {
        this.$el.empty();
        // PF-4860 Careful not to attempt to render deleted column name
        if (this.template && (this.model.get('selectedRowId') || this.model.get('selectedRowId') === 0)
                && this.model.attributes .gridData[this.model.get('selectedRowId')]) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.delegateEvents();
        return this;
    }

}

export default MainNameView;
